import React from 'react';
import { useSettings } from 'services/settings/SettingsContext';
import DetailModal from 'components/modals/DetailModal';
import { DetailCardType } from 'types/DetailPageTypes';
import { HeaderButtonsConfig } from 'types/ButtonTypes';
import { buildInvoiceFieldSections } from './invoiceFieldSections';

// Rename the name of the function:
const InvoiceTemplateModal: React.FC<{ viewKey?: string, itemId?: number, refetchList?: () => void }> = ({ viewKey, itemId, refetchList }) => {
    const { environmentSettings } = useSettings();

    // Specify the parameters of this detail modal:
    const apiObject = 'invoice_template';
    const object = 'invoice_template';

    // Define the header buttons of the modal:
    const headerButtons: HeaderButtonsConfig = {
        leftButtons: [
            {
                type: 'secondary',
                label: 'button.edit_invoice_schedule_button_label',
                action: 'edit_invoice_schedule',
                restrictedRight: ['only_view'],
            },
            {
                type: 'dropdown',
                label: 'button.more_button_label',
                buttons: [
                    {
                        label: 'button.delete_periodic_invoice_button_label',
                        action: 'delete',
                        restrictedRight: ['only_view'],
                        allowedRight: ['can_delete'],
                        onSuccess: 'closeModal',
                    }
                ]
            },
        ],
        rightButtons: [
            {
                type: 'secondary',
                label: 'button.stop_invoice_schedule_button_label',
                action: 'stop_invoice_schedule',
                restrictedRight: ['only_view'],
                condition: [{ field: 'schedule_is_active', values: [true] }]
            },
            {
                type: 'primary',
                label: 'button.resume_invoice_schedule_button_label',
                action: 'resume_invoice_schedule',
                restrictedRight: ['only_view'],
                condition: [{ field: 'schedule_is_active', values: [false] }]
            },
        ]
    }

    // Build the sections of the template, the schedule block comes first
    const sections: DetailCardType[] = [
        { component: 'InvoiceScheduleCard' },
        ...buildInvoiceFieldSections({ itemId, environmentSettings, includeDates: false }),
    ];

    return (
        <DetailModal
            viewKey={viewKey}
            objectType={object}
            apiObject={apiObject}
            itemId={itemId}
            headerButtons={headerButtons}
            statusBar={false}
            sections={sections}
            summary={true}
            refetchList={refetchList}
        />
    );
};

export default InvoiceTemplateModal;
